"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export default (() => {
  let selects = document.querySelectorAll("[data-select]");
  if (selects.length === 0)
    return;
  const defaultOptions = {
    allowHTML: true,
    searchPlaceholderValue: "Search...",
    removeItemButton: true,
    editItems: true,
    searchEnabled: false,
    shouldSort: false,
    itemSelectText: "",
    classNames: {
      containerInner: "form-select"
    }
  };
  selects.forEach((select) => {
    let dataAttr = select.getAttribute("data-select"), template = select.getAttribute("data-select-template"), userOptions, options;
    if (dataAttr !== "")
      userOptions = JSON.parse(dataAttr);
    if (template !== null) {
      options = __spreadProps(__spreadValues(__spreadValues({}, defaultOptions), userOptions), {
        /* eslint-disable indent */
        callbackOnCreateTemplates: function(template2) {
          return {
            item: ({ classNames }, data) => {
              var _a;
              return template2(`
                <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable} ${data.placeholder ? classNames.placeholder : ""}" data-item data-id="${data.id}" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ""} ${data.disabled ? 'aria-disabled="true"' : ""} ${data.placeholder ? "data-placeholder" : ""}>
                    ${data.placeholder || !((_a = data.customProperties) == null ? void 0 : _a.selected) ? data.label : data.customProperties.selected}
                  ${userOptions.removeItemButton === false ? "" : `<button type="button" class="choices__button" aria-label="Remove item" data-button></button>`}
                </div>
              `);
            },
            choice: ({ classNames }, data) => {
              return template2(`
                <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable} ${data.placeholder ? classNames.placeholder : ""}" data-select-text="${this.config.itemSelectText}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : "data-choice-selectable"} data-id="${data.id}" data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
                  <div>
                    ${data.label}
                    ${(() => {
                let output = "";
                if (data.customProperties) {
                  for (const key in data.customProperties) {
                    if (Object.prototype.hasOwnProperty.call(
                      data.customProperties,
                      key
                    ) && key !== "selected") {
                      output += data.customProperties[key];
                    }
                  }
                }
                return output;
              })()}
                  </div>
                </div>
              `);
            }
          };
        }
        /* eslint-enable indent */
      });
    } else {
      options = __spreadValues(__spreadValues({}, defaultOptions), userOptions);
    }
    const choices = new Choices(select, options);
  });
})();
